import {call, put, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  getCustomers,
  getCustomersLabelValueAsync,
  sendCustomerData,
} from "../AsyncActions/customers.async";
import {
  saveCustomersList,
  saveCustomersLabelValue,
  saveSelectedCustomer,
} from "../Actions/customers.actions";

function* getCustomersList(action = {}) {
  const {pageUrl = "", callback = () => {}} = action;
  try {
    const response = yield call(getCustomers, pageUrl);
    if (response) {
      yield put(saveCustomersList(response?.data));
      callback(response?.data);
    }
  } catch (e) {
    return e;
  }
}

function* getCustomersLabelValue() {
  try {
    const response = yield call(getCustomersLabelValueAsync);
    if (response) {
      yield put(saveCustomersLabelValue(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* sendCustomerDataRequest(action = {}) {
  try {
    const {payload = {}, routeDetails, callback = () => {}} = action;
    const response = yield call(sendCustomerData, payload);
    if (response?.data) {
      if (routeDetails?.defaultRoute) {
        yield put(saveSelectedCustomer(response?.data?.data));
      }
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* customersSaga() {
  yield takeLatest(actions.REQUEST_GET_CUSTOMERS_LIST_SAGA, getCustomersList);
  yield takeLatest(actions.GET_CUSTOMERS_LABEL_VALUE_LIST, getCustomersLabelValue);
  yield takeLatest(actions.REQUEST_SEND_CUSTOMER_DATA_SAGA, sendCustomerDataRequest);
}
